(() => {
  const searchShell = document.querySelector('[data-pk9-search]');
  const searchInput = searchShell?.querySelector('[data-pk9-search-input]');
  const searchResults = searchShell?.querySelector('[data-pk9-search-results]');
  let searchTimer = null;
  let searchController = null;
  let lastSearchTrigger = null;

  const openSearch = (trigger) => {
    if (!searchShell) return;
    lastSearchTrigger = trigger || document.activeElement;
    searchShell.hidden = false;
    searchShell.setAttribute('aria-hidden', 'false');
    document.documentElement.classList.add('pk9-search-open');
    document.body.classList.add('pk9-search-open');
    window.requestAnimationFrame(() => searchInput?.focus());
  };

  const closeSearch = () => {
    if (!searchShell || searchShell.hidden) return;
    searchShell.hidden = true;
    searchShell.setAttribute('aria-hidden', 'true');
    document.documentElement.classList.remove('pk9-search-open');
    document.body.classList.remove('pk9-search-open');
    searchController?.abort();
    lastSearchTrigger?.focus?.();
  };

  const resultImage = (item) => {
    const image = item.featured_image?.url || item.featured_image || item.image?.url || item.image;
    if (!image || typeof image !== 'string') {
      const placeholder = document.createElement('span');
      placeholder.className = 'pk9-search-v66__result-placeholder';
      return placeholder;
    }
    const node = document.createElement('img');
    node.src = image;
    node.alt = '';
    node.loading = 'lazy';
    return node;
  };

  const buildResult = (item) => {
    const link = document.createElement('a');
    link.className = 'pk9-search-v66__result';
    link.href = item.url || '#';
    link.append(resultImage(item));
    const title = document.createElement('strong');
    title.textContent = item.title || 'Résultat';
    const arrow = document.createElement('span');
    arrow.textContent = '↗';
    link.append(title, arrow);
    return link;
  };

  const renderResults = (results) => {
    if (!searchResults) return;
    searchResults.replaceChildren();
    const groups = [
      ['Produits', results.products || []],
      ['Collections & univers', results.collections || []],
      ['Pages', results.pages || []]
    ].filter(([, items]) => items.length);

    if (!groups.length) {
      const empty = document.createElement('p');
      empty.className = 'pk9-search-v66__empty';
      empty.textContent = 'Aucun résultat. Essayez un univers, un type de vêtement ou le nom d’un club.';
      searchResults.append(empty);
      return;
    }

    groups.forEach(([label, items]) => {
      const group = document.createElement('section');
      group.className = 'pk9-search-v66__group';
      const heading = document.createElement('h3');
      heading.textContent = label;
      const list = document.createElement('div');
      list.className = 'pk9-search-v66__list';
      items.slice(0, 6).forEach((item) => list.append(buildResult(item)));
      group.append(heading, list);
      searchResults.append(group);
    });
  };

  const predictiveSearch = async (query) => {
    if (!searchShell?.dataset.suggestUrl || query.length < 2) {
      searchResults?.replaceChildren();
      return;
    }
    searchController?.abort();
    searchController = new AbortController();
    const url = new URL(searchShell.dataset.suggestUrl, window.location.origin);
    url.searchParams.set('q', query);
    url.searchParams.set('resources[type]', 'product,collection,page');
    url.searchParams.set('resources[limit]', '6');
    url.searchParams.set('resources[options][unavailable_products]', 'last');

    try {
      const response = await fetch(url.toString(), {
        headers: { Accept: 'application/json' },
        signal: searchController.signal
      });
      if (!response.ok) throw new Error('Predictive search unavailable');
      const payload = await response.json();
      renderResults(payload.resources?.results || {});
    } catch (error) {
      if (error.name === 'AbortError') return;
      if (searchResults) {
        searchResults.replaceChildren();
        const fallback = document.createElement('p');
        fallback.className = 'pk9-search-v66__empty';
        fallback.textContent = 'La recherche instantanée est momentanément indisponible. Validez votre recherche pour continuer.';
        searchResults.append(fallback);
      }
    }
  };

  document.addEventListener('click', (event) => {
    const searchTrigger = event.target.closest('[data-pk9-search-open]');
    if (searchTrigger) {
      event.preventDefault();
      openSearch(searchTrigger);
      return;
    }

    if (event.target.closest('[data-pk9-search-close]')) {
      event.preventDefault();
      closeSearch();
      return;
    }

    if (event.target.closest('[data-pk9-open-menu]')) {
      event.preventDefault();
      const menuToggle = document.querySelector('[data-menu-toggle]');
      if (menuToggle?.getAttribute('aria-expanded') !== 'true') menuToggle?.click();
    }

    const productLink = event.target.closest('.template-collection .product-card a[href*="/products/"]');
    if (productLink) {
      sessionStorage.setItem(`pk9-scroll:${location.pathname}${location.search}`, String(window.scrollY));
    }
  });

  searchInput?.addEventListener('input', () => {
    window.clearTimeout(searchTimer);
    const query = searchInput.value.trim();
    searchTimer = window.setTimeout(() => predictiveSearch(query), 180);
  });

  document.querySelectorAll('[data-pk9-mobile-accordion]').forEach((details) => {
    details.addEventListener('toggle', () => {
      if (!details.open) return;
      document.querySelectorAll('[data-pk9-mobile-accordion]').forEach((other) => {
        if (other !== details) other.open = false;
      });
    });
  });

  document.addEventListener('keydown', (event) => {
    if (event.key === 'Escape' && searchShell && !searchShell.hidden) closeSearch();
  });

  if (document.body.classList.contains('template-collection') && document.referrer.includes('/products/')) {
    const saved = sessionStorage.getItem(`pk9-scroll:${location.pathname}${location.search}`);
    if (saved) window.setTimeout(() => window.scrollTo({ top: Number(saved), behavior: 'auto' }), 80);
  }
})();
